import Home from "./Components/Home.svelte"
import Assessor from "./Components/Assessor.svelte"

const routes = [
    {
        name: '/',
        component: Home,
    },
    {
        name: '/assessor',
        component: Assessor,
    }
];

export { routes }